<template>
  <div>
    <div v-if="isPc || isTablet" class="location_wrap">
      <div class="location">
        <template v-if="root2">
          <span>{{ root2 }}</span>
          <span class="svg_next">></span>
        </template>
        <div class="current">
          <router-link
            :to="{
              name: 'category_books',
              params: {
                category: category.code,
                subCategory: category.code
              }
            }"
          >
            <span class="txt">{{ category.label }}</span>
          </router-link>
        </div>
        <template v-if="subcategory && subcategory.label">
          <span class="svg_next">></span>
          <router-link
            :to="{
              name: 'category_books',
              params: {
                category: category.code,
                subCategory: subcategory.code,
                subCategoryNm: subcategory.label
              }
            }"
          >
            <span class="txt">{{ subcategory.label }}</span>
          </router-link>
        </template>
      </div>
    </div>
    <div v-if="isMobile" class="location_wrap">
      <div class="current">
        <router-link
          :to="{
            name: 'category_books',
            params: {
              category: category.code,
              subCategory: category.code
            }
          }"
        >
          <span class="txt">{{ category.label }}</span>
        </router-link>
      </div>
      <div class="svg_next">></div>
      <div v-if="subcategory" class="chapter">
        <router-link
          :to="{
            name: 'category_books',
            params: {
              category: category.code,
              subCategory: subcategory.code
            }
          }"
        >
          <span class="txt">{{ subcategory.label }}</span>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import responsiveMixin from '@/mixins/responsive'
export default {
  name: 'BaseSubbar',
  mixins: [responsiveMixin],
  props: {
    links: {
      type: Array,
      default: null
    },
    root: {
      type: String,
      default: ''
    },
    root2: {
      type: String,
      default: null
    },
    current: {
      type: String,
      default: null
    },
    category: {
      type: Object,
      default: null
    },
    subcategory: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      showSubbarMenu: false
    }
  },
  methods: {
    toggleSubbarMenu() {
      this.showSubbarMenu = !this.ShowSubbarMenu
    },
    closeSubbarMenu() {
      this.showSubbarMenu = false
    }
  }
}
</script>
<style lang="scss" scoped>
.location_wrap {
  max-width: 980px;
  margin: 48px auto 0;
}
.location span.txt {
  font-weight: 500;
  color: #39a5c1;
}
.location span,
.location > div {
  font-size: 16px;
}
@media (max-width: 1024px) {
  .location_wrap {
    margin: 0 auto;
    padding: 10px 20px 0px 20px;
  }
}
@media (max-width: 768px) {
  .location_wrap {
    margin: 15px auto 0;
  }
}
@media (max-width: 480px) {
  .location_wrap {
    display: flex;
    gap: 5px;
    margin: 0;
    padding: 0;
    border-bottom: none;
  }
  .current,
  .chapter {
    a {
      span {
        color: #646464;
        font-family: 'pretendard-medium';
        font-size: 14px;
      }
    }
  }
}
</style>
